<template>
  <div class="research_group_container">
    <div class="hd research-background-color">
      <span class="icon icon-left navshare" @click="goBack" v-if="!isWapp"></span>
      <span class="header_title">物流信息</span>
    </div>
    <div class="box">
      <div class="bd">
        <div style="margin-left: 4vw;margin-top: 5vw;">
          <svg width="12px" height="17px" viewBox="0 0 12 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
            <title>形状</title>
            <desc>Created with Sketch.</desc>
            <g id="课题组" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="执行中订单详情" transform="translate(-25.000000, -118.000000)" fill="#5878FA" fill-rule="nonzero">
                <g id="地点" transform="translate(25.000000, 118.000000)">
                  <path d="M5.99998382,0 C2.68650826,0 0,2.76794957 0,6.18183182 C0,11.2045379 5.99998382,17 5.99998382,17 C5.99998382,17 12,11.2045712 12,6.18183182 C12,2.76794957 9.31350792,0 5.99998382,0 Z M5.99998382,9.27270606 C4.34252624,9.27270606 3,7.88874794 3,6.18181515 C3,4.47488236 4.34251007,3.09090758 5.99998382,3.09090758 C7.65676205,3.09090758 8.99998382,4.47488236 8.99998382,6.18181515 C8.99998382,7.88873128 7.6567297,9.27270606 5.99998382,9.27270606 Z" id="形状"></path>
                </g>
              </g>
            </g>
          </svg>
        </div>

        <div style="margin-left: 3vw;margin-top: 7vw;">
          <span class="phone" :lines="undefined">{{expressInfo.expressMobile}}</span>
          <span class="luWei" :lines="undefined">{{expressInfo.expressContactor}}</span>
          <span class="summary" :lines="undefined">{{expressInfo.expressAddress}}</span>
        </div>
      </div>
      <div class="main">
        <span class="expressInformation" :lines="undefined">快递信息</span>
        <div class="empty" />
        <div class="group">
          <span class="expressCompany" :lines="undefined">快递公司</span>
          <span class="zhongtongExpress" :lines="undefined">{{expressInfo.expressCompanyName}}</span>
        </div>
        <div class="div" />
        <div class="container_2">
          <span class="expressNumber" :lines="undefined">快递单号</span>
          <div class="group_2" id="tag-copy" :data-clipboard-text="expressInfo.expressNo" @click="copy">
            <span class="num" :lines="undefined">{{expressInfo.expressNo}}</span>
            <div class="tagWrap">
              <span class="tag">复制</span>
            </div>
          </div>
        </div>
        <div class="empty_2" />
        <div class="block_3">
          <span class="sendStatus" :lines="undefined">寄/发送状态</span>
          <span class="sent" :lines="undefined">{{expressInfo.sendStatusName}}</span>
        </div>
        <div class="div_2" />
        <div class="group_3">
          <span class="sender" :lines="undefined">寄/发送人</span>
          <span class="human" :lines="undefined">{{expressInfo.receiver}}</span>
        </div>
        <div class="empty_3" />
        <div class="container_3">
          <span class="sendingTime" :lines="undefined">寄/发送时间</span>
          <span class="text" :lines="undefined">{{expressInfo.sendDTString}}</span>
        </div>
        <div class="div_3" />
        <div class="block_4">
          <span class="signReceiveStatus" :lines="undefined">签/接收状态</span>
          <span class="signed" :lines="undefined">{{expressInfo.receiveStatusName}}</span>
        </div>
        <div class="empty_4" />
        <div class="group_4">
          <span class="signingRecipient" :lines="undefined">签/接收人</span>
          <span class="human_2" :lines="undefined">{{expressInfo.receiveStatusName}}</span>
        </div>
        <div class="div_4" />
        <div class="container_4">
          <span class="signReceiveTime" :lines="undefined">签/接收时间</span>
          <span class="text_2" :lines="undefined">{{expressInfo.receiveDTString}}</span>
        </div>
      </div>
      <div class="ft" />
    </div>
  </div>
</template>

<script>
    import $ from 'jquery'
    import Clipboard from 'clipboard'
    import EMKT from '../../../../emkt'
    export default {
      name: 'ExpressInfo',
      data () {
        return {
          expressInfo: this.$route.query.expressOutList[0],
          order: {},
          isWapp: EMKT.isWapp
        }
      },
      mounted () {
        this.order = EMKT.getLocalStorage('ResearchGroupOrder')
      },
      methods: {
        goBack () {
          let item = EMKT.getLocalStorage('chosenItem')
                // if (this.type === 'Tool' || (this.type === 'Service' && !this.subType)) {
          this.$router.push({name: 'Progress', query: {item: item}})
                // } else {
                //
                // }

                // this.$router.go(-1)
        },
        copy () {
          console.log(111)
          const clipboard = new Clipboard('#tag-copy')
                // 或者不绑定 const clipboard = new Clipboard("#tag-copy", () => '复制的内容')
          clipboard.on('success', e => {
            $.toast('复制成功')
            clipboard.destroy() // 释放内存
          })
          clipboard.on('error', e => {
            $.toast('该浏览器不支持自动复制')
            clipboard.destroy()
          })
        }
      }
}
</script>

<style scoped>
  .research_group_container {
    overflow-y:scroll;
    overflow-x:hidden;
    /*-webkit-overflow-scrolling:touch;*/
    height:100%;
  }

  .navshare {
    position: absolute;
    left: 6.67vw;
    width: 10vw;
    height: 10vw;
    padding-top: 2vw;
    color:#ffffff;
  }

  .header_title {
    opacity: 1;
    /*margin-left: 29.33vw;*/
    max-width: 60.53vw;
    height: 5.87vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.87vw;
    white-space: nowrap;
    color: #ffffff;
    font-size: 4.27vw;
    font-weight: 400;
  }



  .hd {
    display: flex;
    position: fixed;
    top:0;
    left:0;
    align-items: center;
    flex-direction: row;
    /*background-color: #5878fa;*/
    width: 100vw;
    height: 14.93vw;
    z-index: 10;
    justify-content: center;
  }
  .box {
    display: flex;
    align-items: center;
    flex-direction: column;
    background-color: #FAFAFA;
    width: 100vw;
    height: 243.2vw;
    margin-top: 15vw;
  }
  .bd {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: row;
    margin-top: 2.67vw;
    border-radius: 2.67vw;
    background-color: #ffffff;
    width: 94.67vw;
    height: 16.53vw;
  }

  .phone {
    position: absolute;
    top: 3.47vw;
    left: 22.2vw;
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #929292;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .luWei {
    position: absolute;
    top: 3.47vw;
    left: 10.13vw;
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .placeholder {
    position: relative;
    margin-top: 5.87vw;
    margin-right: 2.93vw;
    margin-left: 4vw;
    width: 3.2vw;
    height: 4.53vw;
  }

  .summary {
    position: relative;
    opacity: 1;
    margin-top: 8.53vw;
    max-width: 84.53vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .main {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 2.67vw;
    border-width: 1px;
    border-style: solid;
    border-radius: 2.67vw;
    border-color: rgba(239, 238, 243, 1);
    background-color: #ffffff;
    width: 94.67vw;
    height: 101.07vw;
  }

  .expressInformation {
    position: relative;
    opacity: 1;
    margin-top: 3.47vw;
    margin-left: 4vw;
    max-width: 87.2vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.73vw;
    font-weight: bold;
  }

  .empty {
    position: relative;
    margin-top: 2.13vw;
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(239, 238, 243, 1);
    width: 94.4vw;
    height: 0.27vw;
  }

  .group {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 2.67vw;
    width: 86.67vw;
    height: 5.33vw;
  }

  .expressCompany {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .zhongtongExpress {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .div {
    position: relative;
    margin-top: 2.67vw;
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(239, 238, 243, 1);
    width: 94.4vw;
    height: 0.27vw;
  }

  .container_2 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 2.4vw;
    width: 86.67vw;
    height: 6.13vw;
  }

  .expressNumber {
    opacity: 1;
    max-width: 41.87vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .group_2 {
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 6.13vw;
  }

  .num {
    opacity: 1;
    margin-right: 1.33vw;
    max-width: 46.4vw;
    height: 5.33vw;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .tagWrap {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: row;
    border-width: 1px;
    border-style: solid;
    border-radius: 2.93vw;
    border-color: rgba(88, 120, 250, 1);
    padding-right: 2.4vw;
    padding-left: 2.4vw;
    height: 6.13vw;
  }

  .tag {
    opacity: 1;
    text-align: center;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .empty_2 {
    position: relative;
    margin-top: 2.13vw;
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(239, 238, 243, 1);
    width: 94.67vw;
    height: 0.27vw;
  }

  .block_3 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 2.67vw;
    width: 86.67vw;
    height: 5.33vw;
  }

  .sendStatus {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .sent {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .div_2 {
    position: relative;
    margin-top: 2.67vw;
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(239, 238, 243, 1);
    width: 94.4vw;
    height: 0.27vw;
  }

  .group_3 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 2.67vw;
    width: 86.67vw;
    height: 5.33vw;
  }

  .sender {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .human {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .empty_3 {
    position: relative;
    margin-top: 2.93vw;
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(239, 238, 243, 1);
    width: 94.4vw;
    height: 0.27vw;
  }

  .container_3 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 2.67vw;
    width: 86.67vw;
    height: 5.33vw;
  }

  .sendingTime {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .text {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .div_3 {
    position: relative;
    margin-top: 2.93vw;
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(239, 238, 243, 1);
    width: 94.4vw;
    height: 0.27vw;
  }

  .block_4 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 2.93vw;
    width: 86.67vw;
    height: 5.33vw;
  }

  .signReceiveStatus {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .signed {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .empty_4 {
    position: relative;
    margin-top: 2.93vw;
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(239, 238, 243, 1);
    width: 94.4vw;
    height: 0.27vw;
  }

  .group_4 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 2.93vw;
    width: 86.67vw;
    height: 5.33vw;
  }

  .signingRecipient {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .human_2 {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .div_4 {
    position: relative;
    margin-top: 2.93vw;
    border-top-width: 0.7px;
    border-top-style: solid;
    border-top-color: rgba(239, 238, 243, 1);
    width: 94.4vw;
    height: 0.27vw;
  }

  .container_4 {
    display: flex;
    position: relative;
    align-items: center;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 2.93vw;
    width: 86.67vw;
    height: 5.33vw;
  }

  .signReceiveTime {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #424242;
    font-size: 3.2vw;
    font-weight: 400;
  }

  .text_2 {
    opacity: 1;
    line-height: 5.33vw;
    white-space: nowrap;
    color: #5878fa;
    font-size: 3.2vw;
    font-weight: 400;
  }
</style>



// WEBPACK FOOTER //
// ExpressInfo.vue?601e18f8